import * as Yup from 'yup';
import { Audiobook } from 'types';

export const getAudiobookValidationSchema = (t: (key: string) => string, values: Audiobook) => {
  if (!values.published) {
    return Yup.object().shape({
      name: Yup.string().required(t('common_required')),
      mediaTypeId: Yup.number().required(t('common_required')),
    });
  }

  return Yup.object().shape({
    name: Yup.string().required(t('common_required')),
    author: Yup.string().required(t('common_required')),
    publisher: Yup.string().required(t('common_required')),
    description: Yup.string().required(t('common_required')),
    image: Yup.string().required(t('common_required')),
    releaseDate: Yup.string().required(t('common_required')),
    releaseYear: Yup.number().required(t('common_required')),
    language: Yup.string().required(t('common_required')),
    mediaTypeId: Yup.number().required(t('common_required')),
    categoryIds: Yup.array().min(1, t('common_required')),
    targetGroupIds: Yup.array().min(1, t('common_required')),
    ebookStartSkip: Yup.number()
      .nullable()
      .transform((val, orig) => (orig === '' ? null : val))
      .min(0)
      .notRequired(),
    ebookEndSkip: Yup.number()
      .nullable()
      .transform((val, orig) => (orig === '' ? null : val))
      .min(0)
      .notRequired(),
  });
};
